import axios from 'axios';
import qs from 'qs';

// 查询产品详情
export function queryProducts(data) {
  return axios({
    url: '/mall/app/products/' + data.id,
    method: 'get',
    params: data.obj,
  });
}
// 查询产品的自提门店
export function selfMentionStore(data) {
  return axios({
    url: '/mall/app/products/self_mention/store/' + data,
    method: 'get',
  });
}
// 查询购物车商品数量
export function cartProducttNum(params) {
  return axios({
    url: '/mall/app/cart/count',
    method: 'get',
    params,
  });
}
// 获取产品sku信息
export function productSku(params) {
  return axios({
    url: '/mall/app/product_sku',
    method: 'get',
    params,
  });
}
// 获取商家基本信息
export function storeBasicInformation(data) {
  return axios({
    url: '/mall/app/merchants/' + data.userId + '/basic',
    method: 'get',
    params: data,
  });
}
// 获取商家详细信息
export function merchantsDetails(data) {
  return axios({
    url: '/mall/app/merchants/' + data.userId + '/details',
    method: 'get',
    params: data,
  });
}
// 获取店铺基础详情
export function shopBasicMessage(data) {
  return axios({
    url: '/mall/app/stores/' + data.id,
    method: 'get',
    params: data,
  });
}
// 分页查询产品简要信息
export function summaryInformation(params) {
  return axios({
    url: '/mall/app/products',
    method: 'get',
    params,
  });
}

// 添加到购物车
export function addCarts(data) {
  return axios({
    url: '/mall/app/cart',
    method: 'post',
    data: data,
  });
}
// 提交订单
export function submissionOrders(data) {
  return axios({
    url: '/mall/app/order/submission',
    method: 'post',
    data: data,
  });
}
// 提交订单V2
export function submissionOrdersV2(data) {
  return axios({
    url: '/mall/app/order/submission/v2',
    method: 'post',
    data: data,
  });
}
// 立即购买
export function currentBuy(data) {
  return axios({
    url: `/mall/app/order/buyNow`,
    method: 'post',
    data: data,
  });
}
// 去结算
export function settlement(data) {
  return axios({
    url: `/mall/app/order/settlement`,
    method: 'post',
    data: data,
  });
}
// 去支付
export function toPay(data) {
  return axios({
    url: `/mall/app/order/payment`,
    method: 'post',
    data: data,
  });
}
// 去支付V2
export function toPayV2(data) {
  return axios({
    url: `/mall/app/order/payment/v2`,
    method: 'post',
    data: data,
  });
}
// 采集访客信息
export function dataCollection(data) {
  return axios({
    url: `/mall/app/analysis/collect/visitor`,
    method: 'post',
    data: data,
  });
}
// 更新产品购买信息
export function updateCartMessage(params) {
  return axios({
    url: `/mall/app/cart`,
    method: 'put',
    data: params,
  });
}
// 关闭订单
export function colseOrder(data) {
  return axios({
    url: `/mall/app/order/close/` + data,
    method: 'put',
  });
}

// 删除订单
export function deleteOrder(data) {
  return axios({
    url: `/mall/app/order/` + data,
    method: 'delete',
  });
}
// 确认收货
export function confirmGetProduct(data) {
  return axios({
    url: `/mall/app/order/confirm/` + data,
    method: 'put',
  });
}
// 查询产品可参与的免费拿
export function freeTake(params) {
  return axios({
    url: '/mall/app/free_take/list',
    method: 'get',
    params,
  });
}
// 助力免费拿
export function helpFree(data) {
  return axios({
    url: '/mall/app/free_take/help',
    method: 'post',
    data,
  });
}
// 查询商品分类
export function productCategories(params) {
  console.log('params', params);
  return axios({
    url: '/mall/app/product_categories',
    method: 'get',
    params,
  });
}
// 搜索商品
export function searchProduct(params) {
  return axios({
    url: '/mall/search/product',
    method: 'get',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, {
        indices: false,
      });
    },
  });
}
// 分页查询节省项
export function saveMoney(params) {
  return axios({
    url: '/mall/app/save_money_record/item',
    method: 'get',
    params,
  });
}
// 累计节省金额
export function saveMoneyTotal(params) {
  return axios({
    url: '/mall/app/save_money_record/total',
    method: 'get',
    params,
  });
}